import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { isPast } from 'date-fns'

import { alpha, Box, Toolbar } from '@mui/material'
import { useAppDispatch } from '@/state'
import { ApplicationState } from '@/state/root.models'

import logoutThunk from '@/state/auth/thunk/logout.thunks'
import { colors } from '@/theme/colors.theme'
import { LocalCurrentDateTime } from '@/views/components'

import { uiGlobalSelector } from '@/state/ui/global/slices/index.slices'
import TopBarDropdownComponent from './top-bar-dropdown.component'
import BrandsComponent from './brands.component'

import OpenCrudsComponent from './open-cruds.component'
import useStyles from './style'
import SearchBarComponent from '../player-search-bar/player-search-bar.component'

const TopBarComponent = () => {
  const dispatch = useAppDispatch()

  const { classes } = useStyles()

  const { userSession, token, unauthorized, loggedUser } = useSelector(
    ({ auth }: ApplicationState) => auth,
    shallowEqual,
  )

  const { sidebarStatus } = useSelector(uiGlobalSelector)

  const hasTokenExpired = () => isPast(new Date(userSession?.exp * 1000))

  useEffect(() => {
    const intervalToken = setInterval(() => {
      if (userSession?.exp && userSession?.exp !== 0) {
        if (!unauthorized) {
          dispatch(logoutThunk())
        }

        if (hasTokenExpired() || !token) {
          dispatch(logoutThunk())
        }
      }
    }, 3000)
    return () => clearInterval(intervalToken)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, unauthorized, dispatch, userSession])

  return (
    <Box className={classes.appBarWrapper}>
      <Box className={`${classes.appBar} ${sidebarStatus ? 'open' : 'close'}`}>
        <Toolbar
          sx={{ paddingRight: '0 !important', paddingLeft: '0 !important' }}
        >
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box className={classes.boxBrand}>
                  <BrandsComponent />
                </Box>
                <Box
                  sx={{
                    borderLeft: `1px solid ${alpha(colors.white, 0.1)}`,
                    color: colors.white,
                    height: '40px',
                    mt: '14px',
                    pl: 2,
                    ml: 2,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <LocalCurrentDateTime />
                </Box>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <SearchBarComponent />
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mt={2}
                >
                  <OpenCrudsComponent />
                  {(userSession || loggedUser) && (
                    <Box display="flex" alignItems="center">
                      <TopBarDropdownComponent />
                    </Box>
                  )}
                </Box>
              </Box>
            </>
          </Box>
        </Toolbar>
      </Box>
    </Box>
  )
}

export default TopBarComponent
